import React from 'react';
import { footerLinks } from '../data/mockData';
import { Facebook, Twitter, Instagram, Linkedin, Youtube } from 'lucide-react';
import { appName, copyright } from '../config/branding';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          {/* Logo + Social */}
          <div className="col-span-2 md:col-span-1">
            <a href="/" className="inline-block mb-4">
              <span className="text-2xl font-bold text-[#37b34a]">{appName}</span>
            </a>
            <p className="text-gray-400 text-sm mb-4 leading-relaxed">
              Connecting you with the best local professionals.
            </p>
            <div className="flex items-center gap-3">
              {[
                { icon: Facebook, label: 'Facebook' },
                { icon: Twitter, label: 'Twitter' },
                { icon: Instagram, label: 'Instagram' },
                { icon: Linkedin, label: 'LinkedIn' },
              ].map(({ icon: Icon, label }) => (
                <a
                  key={label}
                  href="#"
                  className="w-9 h-9 rounded-full bg-gray-800 hover:bg-gray-700 flex items-center justify-center text-gray-400 hover:text-white transition-colors duration-200"
                  aria-label={label}
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-gray-400 mb-4">
              Company
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-white text-sm transition-colors duration-200 no-underline"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* For Customers */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-gray-400 mb-4">
              For Customers
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.forCustomers.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-white text-sm transition-colors duration-200 no-underline"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* For Professionals */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-gray-400 mb-4">
              For Professionals
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.forProfessionals.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-white text-sm transition-colors duration-200 no-underline"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-gray-400 mb-4">
              Legal
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.legal.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-white text-sm transition-colors duration-200 no-underline"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex flex-wrap items-center gap-4">
            <p className="text-gray-500 text-sm">
              {copyright}
            </p>
            <button
              onClick={() => typeof window !== 'undefined' && window.__openCookiePreferences && window.__openCookiePreferences()}
              data-testid="footer-cookie-preferences"
              className="text-gray-500 text-xs hover:text-white transition-colors duration-200"
            >
              Cookie preferences
            </button>
          </div>
          <div className="flex items-center gap-4">
            <span className="text-gray-500 text-sm">Available in:</span>
            {['US', 'UK', 'CA', 'AU', 'IE', 'NZ', 'ZA', 'SG'].map((country) => (
              <span key={country} className="text-gray-500 text-xs font-medium hover:text-white transition-colors duration-200 cursor-pointer">
                {country}
              </span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
